import layout from '@/layout/index.vue'

export default {
  path: '/goods_new',
  component: layout,
  redirect: '/goods_new/list',
  name: 'goodsNewLists',
  meta: {
    title: '研发中心',
    icon: 'goods'
  },
  children: [
    {
      path: '/goods_new/list',
      name: 'goodsNewList',
      component: () => import('@/views/goods_new/list/index.vue'),
      meta: {
        title: '新品库',
        icon: 'goods'
      }
    }
  ]
}
